import React, { useState, useEffect } from 'react';
import { HiPlus, HiX, HiTrash, HiDocumentText, HiUserGroup, HiClipboardList, HiOutlineUserGroup, HiPhone, HiOutlineLightBulb, HiOutlineCalendar, HiOutlinePhotograph, HiOutlineInformationCircle, HiOutlineTicket, HiOutlineUsers, HiOutlinePresentationChartLine, HiCalendar, HiQrcode, HiLogout, HiOutlineArchive, HiOutlineAcademicCap } from 'react-icons/hi';
import FlyersManagement from './gestion/FlyersManagement';
import SpeakersManagement from './gestion/SpeakersManagement';
import TopicsManagement from './gestion/TopicsManagement';
import ContactManagement from './gestion/ContactManagement';
import ObjectivesManagement from './gestion/ObjectivesManagement';
import DatesManagement from './gestion/DatesManagement';
import HeroManagement from './gestion/HeroManagement';
import AProposManagement from './gestion/AProposManagement';
import ParticipationManagement from './gestion/ParticipationManagement';
import VisiteursManagement from './gestion/VisiteursManagement';
import ConferencesManagement from './gestion/ConferencesManagement';
import MediaManagement from './gestion/MediaManagement';
import ConferenciersPrincipauxManagement from './gestion/ConferenciersPrincipauxManagement';
import ProgrammeManagement from './gestion/ProgrammeManagement';
import CigsidaChallengeManagement from './gestion/CigsidaChallengeManagement';
import APSISManagement from './gestion/APSISManagement';
import LaboratoriesManagement from './gestion/LaboratoriesManagement';
import FormationManagement from './gestion/FormationManagement';
import ExecutiveFormationsManagement from './gestion/ExecutiveFormationsManagement';
import PointageAppareil from './PointageAppareil';
import { CiCalendar } from "react-icons/ci";
import Login from './Login';
import { supabase } from '../supabaseClient';
import './Gestion.css';
import HistoriqueManagement from './gestion/HistoriqueManagement';
import { editionService } from '../services/editionService';
import SettingsManagement from './gestion/SettingsManagement';
import { HiOutlineCog } from 'react-icons/hi';

function Gestion() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [selectedEdition, setSelectedEdition] = useState(null);
  const [activeTab, setActiveTab] = useState('pointage');
  const [loading, setLoading] = useState(true);
  const [activeEditions, setActiveEditions] = useState([]);
  const [availableEditions, setAvailableEditions] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [newEdition, setNewEdition] = useState({ 
    year: '', 
    name: 'GSIDA', 
    theme: '', 
    copyFrom: null 
  });
  const [isCreating, setIsCreating] = useState(false);

  const tabs = [
    { id: 'hero', label: 'Héro', icon: HiOutlinePhotograph },
    { id: 'apropos', label: 'À Propos', icon: HiOutlineInformationCircle },
    { id: 'programme', label: 'Programme', icon: HiDocumentText },
    { id: 'flyers', label: 'Flyers', icon: HiDocumentText },
    { id: 'speakers', label: 'Intervenants', icon: HiUserGroup },
    { id: 'topics', label: 'Axes', icon: HiClipboardList },
    { id: 'objectives', label: 'Objectifs', icon: HiOutlineLightBulb },
    { id: 'dates', label: 'Dates', icon: HiOutlineCalendar },
    { id: 'conferences', label: 'Conférences', icon: HiOutlinePresentationChartLine },
    { id: 'participation', label: 'Participation', icon: HiOutlineTicket },
    { id: 'visiteurs', label: 'Visiteurs', icon: HiOutlineUsers },
    { id: 'conferenciers_principaux', label: 'Conf. Principaux', icon: HiOutlineUserGroup },
    { id: 'laboratories', label: 'Laboratoires', icon: HiOutlineAcademicCap },
    { id: 'challenge', label: 'Challenge', icon: HiOutlineAcademicCap },
    { id: 'pointage', label: 'Pointage', icon: HiQrcode },
    { id: 'media', label: 'Médiathèque', icon: HiOutlinePhotograph },
    { id: 'historique', label: 'Historique', icon: HiOutlineArchive },
    { id: 'apsis', label: 'APSIS', icon: HiOutlineTicket },
    { id: 'formations', label: 'Formations', icon: HiOutlineAcademicCap },
    { id: 'executive_formations', label: 'Inscr. Executive', icon: HiOutlineAcademicCap },
    { id: 'settings', label: 'Paramètres', icon: HiOutlineCog },
    { id: 'contact', label: 'Contact', icon: HiPhone }
  ];

  // Check authentication on component mount
  useEffect(() => {
    checkAuth();
    loadEditions();

    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_OUT' || !session) {
        setIsAuthenticated(false);
        setSelectedEdition(null);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  const loadEditions = async () => {
    try {
      // Get all editions
      const { data: editions } = await supabase
        .from('editions')
        .select('year, is_active')
        .order('year', { ascending: false });

      if (editions) {
        setAvailableEditions(editions.map(edition => edition.year));
        setActiveEditions(editions.filter(edition => edition.is_active).map(edition => edition.year));
      }
    } catch (error) {
      console.error('Error loading editions:', error);
      // Fallback to empty arrays if database query fails
      setAvailableEditions([]);
      setActiveEditions([]);
    }
  };

  const checkAuth = async () => {
    try {
      const { data: { session } } = await supabase.auth.getSession();

      if (session) {
        // Check if user exists in admin_users table and has admin role
        const { data: adminUser } = await supabase
          .from('admin_users')
          .select('role')
          .eq('email', session.user.email)
          .single();

        if (adminUser && adminUser.role === 'admin') {
          setIsAuthenticated(true);
        }
      }
    } catch (error) {
      console.error('Auth check error:', error);
    } finally {
      setLoading(false);
    }
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'hero': return <HeroManagement selectedEdition={selectedEdition} />;
      case 'apropos': return <AProposManagement selectedEdition={selectedEdition} />;
      case 'programme': return <ProgrammeManagement selectedEdition={selectedEdition} />;
      case 'flyers': return <FlyersManagement selectedEdition={selectedEdition} />;
      case 'speakers': return <SpeakersManagement selectedEdition={selectedEdition} />;
      case 'topics': return <TopicsManagement selectedEdition={selectedEdition} />;
      case 'objectives': return <ObjectivesManagement selectedEdition={selectedEdition} />;
      case 'dates': return <DatesManagement selectedEdition={selectedEdition} />;
      case 'conferences': return <ConferencesManagement selectedEdition={selectedEdition} />;
      case 'participation': return <ParticipationManagement selectedEdition={selectedEdition} />;
      case 'visiteurs': return <VisiteursManagement selectedEdition={selectedEdition} />;
      case 'conferenciers_principaux': return <ConferenciersPrincipauxManagement selectedEdition={selectedEdition} />;
      case 'laboratories': return <LaboratoriesManagement selectedEdition={selectedEdition} />;
      case 'pointage': return <PointageAppareil selectedEdition={selectedEdition} />;
      case 'media': return <MediaManagement selectedEdition={selectedEdition} />;
      case 'challenge': return <CigsidaChallengeManagement selectedEdition={selectedEdition} />;
      case 'historique': return <HistoriqueManagement selectedEdition={selectedEdition} />;
      case 'apsis': return <APSISManagement selectedEdition={selectedEdition} />;
      case 'formations': return <FormationManagement editionYear={selectedEdition} />;
      case 'executive_formations': return <ExecutiveFormationsManagement editionYear={selectedEdition} />;
      case 'contact': return <ContactManagement selectedEdition={selectedEdition} />;
      case 'settings': return <SettingsManagement selectedEdition={selectedEdition} onUpdate={() => loadEditions()} />;
      default: return <HeroManagement selectedEdition={selectedEdition} />;
    }
  };

  const handleLogin = (success) => {
    if (success) {
      setIsAuthenticated(true);
    }
  };

  const handleLogout = async () => {
    try {
      await supabase.auth.signOut();
      setIsAuthenticated(false);
      setSelectedEdition(null);
      setActiveTab('flyers');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const handleCreateEdition = async (e) => {
    e.preventDefault();
    if (!newEdition.year || !newEdition.name) {
      alert('Veuillez remplir au moins l\'année et le nom.');
      return;
    }

    try {
      setIsCreating(true);
      
      // 1. Create the edition record
      const { data: createdEdition, error: createError } = await supabase
        .from('editions')
        .insert([{
          year: newEdition.year,
          name: newEdition.name,
          theme: newEdition.theme,
          is_active: false
        }])
        .select()
        .single();

      if (createError) throw createError;

      // 2. Clone data if requested
      if (newEdition.copyFrom) {
        // Find the source edition ID
        const { data: sourceEd } = await supabase
          .from('editions')
          .select('id')
          .eq('year', newEdition.copyFrom)
          .single();

        if (sourceEd) {
          await editionService.cloneEditionData(sourceEd.id, createdEdition.id);
        }
      }

      await loadEditions();
      setShowCreateModal(false);
      setNewEdition({ year: '', name: 'GSIDA', theme: '', copyFrom: null });
      alert(`Édition ${newEdition.year} créée avec succès !`);
    } catch (error) {
      console.error('Error creating edition:', error);
      alert('Erreur lors de la création de l\'édition. Assurez-vous que l\'année est unique.');
    } finally {
      setIsCreating(false);
    }
  };

  // Set an edition as active
  const setEditionActive = async (year) => {
    try {
      // Set all editions to inactive
      await supabase
        .from('editions')
        .update({ is_active: false })
        .neq('year', year);

      // Set the selected edition to active
      await supabase
        .from('editions')
        .update({ is_active: true })
        .eq('year', year);

      // Refresh editions state
      await loadEditions();
    } catch (error) {
      console.error('Erreur lors de la mise à jour de l\'édition active:', error);
    }
  };


  if (loading) {
    return (
      <div className="gestion-page">
        <div className="gestion-container">
          <div style={{ textAlign: 'center', padding: '50px' }}>
            <p>Vérification de l'authentification...</p>
          </div>
        </div>
      </div>
    );
  }

  // Show login page if not authenticated
  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} />;
  }

  // If no edition is selected, show edition selection
  if (!selectedEdition) {
    return (
      <div className="gestion-page">
        <div className="gestion-container">
          <div className="gestion-header">
            <div className="header-with-logout">
              <div>
                <h1>Panneau d'Administration</h1>
                <p>Sélectionnez une édition pour gérer le contenu</p>
              </div>
              <button
                className="logout-btn"
                onClick={handleLogout}
                title="Déconnexion"
              >
                <HiLogout />
                Déconnexion
              </button>
            </div>
          </div>

          <div className="edition-selection">
            <div className="selection-actions" style={{ marginBottom: '20px', display: 'flex', justifyContent: 'flex-end' }}>
              <button 
                className="add-btn" 
                onClick={() => setShowCreateModal(true)}
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '8px', 
                  backgroundColor: '#002b5b', 
                  color: 'white', 
                  padding: '10px 20px', 
              
                  border: 'none', 
                  cursor: 'pointer',
                  fontWeight: '500'
                }}
              >
                <HiPlus /> Créer un Nouveau Congrès / Édition
              </button>
            </div>

            {availableEditions.length === 0 ? (
              <div className="no-editions-message">
                <p>Aucune édition n'est disponible dans la base de données.</p>
                <p>Veuillez utiliser le bouton ci-dessus pour créer une édition.</p>
              </div>
            ) : (
              <div className="edition-grid">
                {availableEditions.map(year => (
                  <div
                    key={year}
                    className={`edition-card ${activeEditions.includes(year) ? 'active-edition' : ''}`}
                    onClick={() => setSelectedEdition(year)}
                  >
                    <CiCalendar className="edition-icon" />
                    <h3>ÉDITION {year}</h3>
                    <p>Gérer le contenu de {year}</p>
                    {activeEditions.includes(year) && (
                      <span className="active-badge">Édition Active</span>
                    )}
                    {/* Add button to set as active if not already active */}
                    {!activeEditions.includes(year) && (
                      <button
                        className="set-active-btn"
                        onClick={e => {
                          e.stopPropagation();
                          setEditionActive(year);
                        }}
                        style={{ marginTop: 10, marginRight: 10 }}
                      >
                        Définir comme édition active
                      </button>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Create Edition Modal */}
          {showCreateModal && (
            <div className="modal-overlay" onClick={() => !isCreating && setShowCreateModal(false)} style={{
              position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
              backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000
            }}>
              <div className="modal-container" onClick={e => e.stopPropagation()} style={{
                backgroundColor: 'white', padding: '30px', borderRadius: '10px', width: '400px', maxWidth: '90%'
              }}>
                <div className="modal-header" style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <h2 style={{ margin: 0 }}>Nouveau Congrès / Édition</h2>
                  <button onClick={() => !isCreating && setShowCreateModal(false)} style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: '20px' }}><HiX /></button>
                </div>
                <form onSubmit={handleCreateEdition}>
                  <div className="form-group" style={{ marginBottom: '15px' }}>
                    <label style={{ display: 'block', marginBottom: '5px' }}>Année (ex: 2026)</label>
                    <input 
                      type="text" 
                      required 
                      value={newEdition.year} 
                      onChange={e => setNewEdition({...newEdition, year: e.target.value})}
                      placeholder="Ex: 2026"
                      style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ddd' }}
                    />
                  </div>
                  <div className="form-group" style={{ marginBottom: '15px' }}>
                    <label style={{ display: 'block', marginBottom: '5px' }}>Nom du Congrès</label>
                    <input 
                      type="text" 
                      required 
                      value={newEdition.name} 
                      onChange={e => setNewEdition({...newEdition, name: e.target.value})}
                      placeholder="Ex: GSIDA 2026"
                      style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ddd' }}
                    />
                  </div>
                  <div className="form-group" style={{ marginBottom: '15px' }}>
                    <label style={{ display: 'block', marginBottom: '5px' }}>Thème (Optionnel)</label>
                    <input 
                      type="text" 
                      value={newEdition.theme} 
                      onChange={e => setNewEdition({...newEdition, theme: e.target.value})}
                      placeholder="Thème du congrès"
                      style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ddd' }}
                    />
                  </div>
                  {availableEditions.length > 0 && (
                    <div className="form-group" style={{ marginBottom: '20px' }}>
                      <label style={{ display: 'block', marginBottom: '5px' }}>Cloner les données de :</label>
                      <select 
                        value={newEdition.copyFrom || ''} 
                        onChange={e => setNewEdition({...newEdition, copyFrom: e.target.value || null})}
                        style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ddd' }}
                      >
                        <option value="">-- Ne pas cloner (Partir de zéro) --</option>
                        {availableEditions.map(year => (
                          <option key={year} value={year}>{year}</option>
                        ))}
                      </select>
                      <small style={{ color: '#666', marginTop: '5px', display: 'block' }}>
                        Ceci copiera les paramètres, textes, objectifs, axes, etc.
                      </small>
                    </div>
                  )}
                  <div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <button 
                      type="button" 
                      onClick={() => setShowCreateModal(false)}
                      disabled={isCreating}
                      className="btn-secondary"
                      style={{ padding: '10px 20px', cursor: 'pointer' }}
                    >Annuler</button>
                    <button 
                      type="submit" 
                      disabled={isCreating}
                      className="btn-primary"
                      style={{ padding: '10px 20px', cursor: 'pointer', backgroundColor: '#002b5b', color: 'white', border: 'none', borderRadius: '5px' }}
                    >
                      {isCreating ? 'Création en cours...' : 'Créer l\'Édition'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="gestion-page">
      <div className="gestion-container">
        <div className="gestion-header">
          <div className="header-with-edition">
            <div>
              <h1>Panneau d'Administration</h1>
              <p>Gérez tous les contenus du site GSIDA {selectedEdition}</p>
            </div>
            <div className="header-actions">
              <button
                className="change-edition-btn"
                onClick={() => setSelectedEdition(null)}
              >
                <HiCalendar />
                Chang-d'édition
              </button>
              <button
                className="logout-btn"
                onClick={handleLogout}
                title="Déconnexion"
              >
                <HiLogout />
                Déconnexion
              </button>
            </div>
          </div>
        </div>

        <div className="admin-tabs">
          {tabs.map(tab => {
            const IconComponent = tab.icon;
            return (
              <button
                key={tab.id}
                className={`tab-btn ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                <span className="tab-icon">
                  <IconComponent />
                </span>
                {tab.label}
              </button>
            );
          })}
        </div>

        <div className="admin-content">
          {renderTabContent()}
        </div>
      </div>
    </div>
  );
}

export default Gestion;
